// Base64加密函数
function encodeToBase64(data) {
  try {
    if (typeof data === 'object') {
      // 如果是对象，先转换为JSON字符串
      data = JSON.stringify(data);
    }
    // 使用btoa进行Base64编码
    return btoa(data);
  } catch (error) {
    console.error('Base64加密错误:', error);
    return null;
  }
}

  // const decodedStr = Buffer.from(encodeURIComponent(base64Str), 'base64').toString('utf8');

  //   // 2. 解析为 JSON 对象（让数据更易读取和使用）
  //   const decodedObj = JSON.parse(decodedStr);
  //   return decodedObj;
// Base64解密函数（与encodeToBase64完全对应）
/**
 * 增强容错版 Base64 解码（解决 atob InvalidCharacterError）
 * @param {string} base64Str - URL 参数中的 Base64 字符串
 * @returns {object} 解码后的对象，失败返回空对象
 */
function decodeFromBase64(base64Str) {
    try {
        // 1. 修复 Base64 字符串格式
        base64Str = base64Str.replace(/-/g, '+').replace(/_/g, '/');
        
        // 2. 移除多余的 = 字符，只保留必要的
        base64Str = base64Str.replace(/=+$/, '');
        
        // 3. 添加必要的 = 字符以确保长度是 4 的倍数
        while (base64Str.length % 4) {
            base64Str += '=';
        }
        
        // 4. 使用浏览器原生的 atob 进行解码
        const decodedStr = decodeURIComponent(escape(atob(base64Str)));
        
        // 5. 解析为 JSON 对象
        return JSON.parse(decodedStr);
    } catch (error) {
        console.error('Base64解码错误:', error);
        console.error('错误的Base64字符串:', base64Str);
        return {};
    }
}
/**
 * 获取URL参数
 * @returns {Object} 包含所有URL参数的对象
 */
function getRequestParams() {
  const url = location.href;
  // 忽略 # 后的哈希部分，提取 ? 后的查询字符串
  const urlWithoutHash = url.split('#')[0];
  const queryString = urlWithoutHash.split('?')[1];
  // 存在返回字符串，不存在返回空字符串
  return queryString || '';
}


// 导出Base64相关函数
export { getRequestParams, encodeToBase64, decodeFromBase64 };
